/* Uresta — durable in-page anchor resolution (EMI-983).
 * Template JSON stores anchor targets as "#section--<sectionKey>" so no theme
 * numeric is embedded. On load, each such href is rewritten to the id Shopify
 * actually rendered for that section key on this theme.
 * An anchor whose key is not on the page is left unchanged (same dead behaviour
 * as a stale numeric, but self-healing on every theme). */
(function () {
  function resolve() {
    var anchors = document.querySelectorAll('a[href^="#section--"]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var key = a.getAttribute('href').slice('#section--'.length);
      if (!key) continue;
      var esc = window.CSS && CSS.escape ? CSS.escape(key) : key.replace(/[^a-zA-Z0-9_-]/g, '');
      var el = document.querySelector('[id^="shopify-section-"][id$="__' + esc + '"]');
      if (el) a.setAttribute('href', '#' + el.id);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolve);
  } else {
    resolve();
  }
})();
